import React, {
  useState,
  useEffect,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  toast,
} from "react-toastify";

import {
  ShieldCheck,
  LockKeyhole,
  ArrowRight,
  Building2,
  Landmark,
  BriefcaseBusiness,
  X,
  Eye,
} from "lucide-react";

import "../styles/login.css";

import logo from "../assets/logo.png";

const Login = ({
  setIsAuthenticated,
}) => {

  const [password, setPassword] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [showForgotModal,
    setShowForgotModal,
  ] = useState(false);

  const [securityAnswers,
    setSecurityAnswers,
  ] = useState({
    color: "",
    hobby: "",
  });

  const [revealedPassword,
    setRevealedPassword,
  ] = useState("");


const [insuranceClients,
  setInsuranceClients,
] = useState([]);

const [investors,
  setInvestors,
] = useState([]);

const [customers,
  setCustomers,
] = useState([]);

const API_BASE =
  "https://client-management-backend-8x91.onrender.com";

  const navigate =
    useNavigate();

/* =========================================
    FETCH DASHBOARD STATS
========================================= */

useEffect(() => {

  const fetchStats = async () => {

    try {

      const [
        insuranceRes,
        investorRes,
        customerRes,
      ] = await Promise.all([

        fetch(
          `${API_BASE}/clients`
        ),

        fetch(
          `${API_BASE}/investors`
        ),

        fetch(
          `${API_BASE}/customers`
        ),

      ]);

      // DEBUG

      console.log(
        "Clients status:",
        insuranceRes.status
      );

      console.log(
        "Investors status:",
        investorRes.status
      );

      console.log(
        "Customers status:",
        customerRes.status
      );

      if (
        !insuranceRes.ok ||
        !investorRes.ok ||
        !customerRes.ok
      ) {

        throw new Error(
          "Failed to fetch stats"
        );

      }

      const insuranceData =
        await insuranceRes.json();

      const investorData =
        await investorRes.json();

      const customerData =
        await customerRes.json();

      console.log(
        "Insurance:",
        insuranceData
      );

      console.log(
        "Investors:",
        investorData
      );

      console.log(
        "Customers:",
        customerData
      );

      setInsuranceClients(
        Array.isArray(
          insuranceData
        )
          ? insuranceData
          : []
      );

      setInvestors(
        Array.isArray(
          investorData
        )
          ? investorData
          : []
      );

      setCustomers(
        Array.isArray(
          customerData
        )
          ? customerData
          : []
      );

    } catch (error) {

      console.error(
        "Stats fetch error:",
        error
      );

      toast.error(
        "Failed to load dashboard stats."
      );

    }

  };

  fetchStats();

}, []);


  /* =========================================
      LOGIN
  ========================================= */

  const handleLogin = (e) => {

    e.preventDefault();

    setLoading(true);

    setTimeout(() => {

      const correctPassword =
        "rcsadmin";

      if (
        password ===
        correctPassword
      ) {

        sessionStorage.setItem(
          "authenticated",
          "true"
        );

        setIsAuthenticated(
          true
        );

        toast.success(
          "Access Granted"
        );

        navigate("/");

      } else {

        toast.error(
          "Incorrect password."
        );

      }

      setLoading(false);

    }, 1800);
  };

  /* =========================================
      SECURITY QUESTIONS
  ========================================= */

  const handleVerifyAnswers =
    () => {

      const correctColor =
        "yellow";

      const correctHobby =
        "sleep";

      if (

        securityAnswers.color
          .trim()
          .toLowerCase() ===
          correctColor &&

        securityAnswers.hobby
          .trim()
          .toLowerCase() ===
          correctHobby

      ) {

        setRevealedPassword(
          "rcsadmin"
        );

        toast.success(
          "Verification successful."
        );

      } else {

        toast.error(
          "Incorrect answers."
        );

      }
    };


/* =========================================
    LIVE STATS
========================================= */

// TOTAL CLIENTS

const totalClients =

  insuranceClients.length +

  investors.length +

  customers.length;

// ACTIVE INVESTOR FUNDS

const managedFunds =

  investors

    .filter(
      (inv) =>
        inv.status
          ?.toLowerCase() ===
          "active"
    )

    .reduce(
      (sum, inv) =>

        sum +

        Number(
          inv.account_balance || 0
        ),

      0
    );

// ACTIVE INSURANCE POLICIES

const activePolicies =

  insuranceClients.filter(
    (client) => {

      const renewalDate =
        new Date(

          client.effective_next_renewal ||

          client.renewal_date

        );

      return (
        renewalDate >=
        new Date()
      );
    }
  );

// EXPIRED POLICIES

const expiredPolicies =

  insuranceClients.filter(
    (client) => {

      const renewalDate =
        new Date(

          client.effective_next_renewal ||

          client.renewal_date

        );

      return (
        renewalDate <
        new Date()
      );
    }
  );

// RETENTION %

const retentionRate =

  insuranceClients.length > 0

    ? (

        (
          activePolicies.length /

          insuranceClients.length
        ) * 100

      ).toFixed(1)

    : "0.0";





  return (

    <div className="rcs-login-modern-page">

      {/* BACKGROUND */}

      <div className="rcs-login-modern-glow-one" />

      <div className="rcs-login-modern-glow-two" />

      {/* MAIN */}

      <div className="rcs-login-modern-wrapper">

        {/* LEFT */}

        <div className="rcs-login-modern-left">

          <div className="rcs-login-modern-badge">

            <ShieldCheck size={14} />

            SECURE CLIENT MANAGEMENT

          </div>

          <h1>

            Manage Clients.
            <br />

            Track Growth.
            <br />

            <span>
              Build Trust.
            </span>

          </h1>

          <p>

            Tailored to Manage Insurance Clients,
            Investors and Customer Database.

          </p>

{/* STATS */}

<div className="rcs-login-modern-stats">

  {/* CLIENTS */}

  <div className="rcs-login-modern-stat-card">

    <div className="rcs-login-modern-stat-icon teal">

      <Building2 size={22} />

    </div>

    <h3>
      {totalClients.toLocaleString()}
    </h3>

    <span>
      Total Client Records
    </span>

  </div>

  {/* FUNDS */}

  <div className="rcs-login-modern-stat-card">

    <div className="rcs-login-modern-stat-icon blue">

      <Landmark size={22} />

    </div>

    <h3>

      $

      {managedFunds.toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }
      )}

    </h3>

    <span>
      Managed Investor Funds
    </span>

  </div>

  {/* RETENTION */}

  <div className="rcs-login-modern-stat-card">

    <div className="rcs-login-modern-stat-icon green">

      <BriefcaseBusiness
        size={22}
      />

    </div>

    <h3>
      {retentionRate}%
    </h3>

    <span>

      {activePolicies.length}
      {" "}
      Active •
      {" "}
      {expiredPolicies.length}
      {" "}
      Expired

    </span>

  </div>

</div>

        </div>

        {/* RIGHT */}

        <div className="rcs-login-modern-right">

          <div className="rcs-login-modern-card">

            <div className="rcs-login-modern-logo-circle">

              <img
                src={logo}
                alt="RCS"
              />

            </div>

            <h2>
              Welcome Back
            </h2>

            <p>
              Sign in to access
              the RCS Client
              Management System.
            </p>

            {/* LOGIN FORM */}

            <form
              onSubmit={
                handleLogin
              }
              className="rcs-login-modern-form"
            >

              <div className="rcs-login-modern-input">

                <LockKeyhole
                  size={18}
                />

                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) =>
                    setPassword(
                      e.target.value
                    )
                  }
                  required
                />

              </div>

              <button
                type="submit"
                className="rcs-login-modern-btn"
                disabled={loading}
              >

                {loading ? (

                  <>

                    <div className="rcs-login-modern-spinner" />

                    Authenticating

                  </>

                ) : (

                  <>

                    Access Dashboard

                    <ArrowRight
                      size={18}
                    />

                  </>

                )}

              </button>

            </form>

            {/* FORGOT PASSWORD */}

            <button
              className="rcs-login-modern-forgot-btn"
              onClick={() =>
                setShowForgotModal(
                  true
                )
              }
            >

              Forgot Password?

            </button>

            <div className="rcs-login-modern-footer">

              Protected &
              encrypted RCS
              enterprise access.

            </div>

          </div>

        </div>

      </div>

      {/* =========================================
          FORGOT PASSWORD MODAL
      ========================================= */}

      {showForgotModal && (

        <div className="rcs-security-modal-overlay">

          <div className="rcs-security-modal">

            {/* CLOSE */}

            <button
              className="rcs-security-close"
              onClick={() => {

                setShowForgotModal(
                  false
                );

                setRevealedPassword(
                  ""
                );

              }}
            >

              <X size={18} />

            </button>

            {/* HEADER */}

            <h2>
              Security Verification
            </h2>

            <p>

              Complete the
              security questions
              below to reveal
              the administrator
              password.

            </p>

            {/* QUESTION 1 */}

            <div className="rcs-security-field">

              <label>
                Favourite Color
              </label>

              <input
                type="text"
                placeholder="Enter answer"
                value={
                  securityAnswers.color
                }
                onChange={(e) =>
                  setSecurityAnswers({
                    ...securityAnswers,

                    color:
                      e.target.value,
                  })
                }
              />

            </div>

            {/* QUESTION 2 */}

            <div className="rcs-security-field">

              <label>
                Favourite Hobby
              </label>

              <input
                type="text"
                placeholder="Enter answer"
                value={
                  securityAnswers.hobby
                }
                onChange={(e) =>
                  setSecurityAnswers({
                    ...securityAnswers,

                    hobby:
                      e.target.value,
                  })
                }
              />

            </div>

            {/* PASSWORD DISPLAY */}

            {revealedPassword && (

              <div className="rcs-security-password-box">

                <Eye size={18} />

                <span>

                  Password:
                  {" "}
                  <strong>
                    {
                      revealedPassword
                    }
                  </strong>

                </span>

              </div>

            )}

            {/* ACTIONS */}

            <div className="rcs-security-actions">

              <button
                className="cancel"
                onClick={() => {

                  setShowForgotModal(
                    false
                  );

                  setRevealedPassword(
                    ""
                  );

                }}
              >

                Cancel

              </button>

              <button
                className="verify"
                onClick={
                  handleVerifyAnswers
                }
              >

                Verify

              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default Login;